export enum StatusEnumStoreConciliation {
  NOT_INTEGRATED = "NOT_INTEGRATED",
  OPENED = "OPENED",
  CLOSED = "CLOSED",
  PENDING = "PENDING",
}
